import Module from '../module';

import jumpFactory from '../../libs/jump/jump';

interface OptionsInterface {
	cssId: {
		aboutCardBtnMoreId?: string,
		aboutCardBtnLessId?: string,
		aboutCardExpandedId?: string,
		aboutCardExpandedActiveCls?: string,
		aboutCardExpandedTransitionCls?: string,
		moduleHomeAboutId?: string,
		headerCls?: string
	},
	slug: string
}

interface ServiceInterface {
	jump?: ReturnType<typeof jumpFactory.create>;
}

class About extends Module {

	publicVars: OptionsInterface;
	service: ServiceInterface = {};

	constructor(options: OptionsInterface) {
		super('Home About Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		this.service.jump = jumpFactory.create();
		this.service.jump.init();
	}

	bind() {
		this.msg('bind');

		if(this.publicVars.cssId.aboutCardBtnMoreId) {
			const aboutCardBtnMoreHtml = document.querySelector(this.publicVars.cssId.aboutCardBtnMoreId) as HTMLElement;

			aboutCardBtnMoreHtml.addEventListener('click', () => {
				aboutCardBtnMoreHtml.style.cssText = 'opacity: 0; visibility: hidden;';
				this.showAboutCard();
			});
		}

		if(this.publicVars.cssId.aboutCardBtnLessId) {
			const aboutCardBtnLessHtml = document.querySelector(this.publicVars.cssId.aboutCardBtnLessId) as HTMLElement;

			aboutCardBtnLessHtml.addEventListener('click', () => {
				aboutCardBtnLessHtml.style.cssText = 'opacity: 0; visibility: hidden;';
				this.hideAboutCard();
			});
		}
	}

	showAboutCard() {

		const expandedTransitionCls = this.publicVars.cssId.aboutCardExpandedTransitionCls;

		if(!this.publicVars.cssId.aboutCardExpandedId
			|| !this.publicVars.cssId.aboutCardExpandedActiveCls
			|| !this.publicVars.cssId.aboutCardBtnLessId
			|| !expandedTransitionCls
		) {
			this.errorMsg('missing required aboutCardExpandedId or aboutCardExpandedActiveCls');
			return;
		}

		const contentHtml = document.querySelector(this.publicVars.cssId.aboutCardExpandedId) as HTMLElement;
		const aboutCardBtnLessHtml = document.querySelector(this.publicVars.cssId.aboutCardBtnLessId) as HTMLElement;

		contentHtml.style.cssText = 'height: auto; display: block;';
		const height = contentHtml.offsetHeight + 'px';
		const paddingTop = window.getComputedStyle(contentHtml).paddingTop;

		contentHtml.style.cssText = 'height: 0px; opacity: 0; padding-top: 0px;';

		contentHtml.classList.add(this.publicVars.cssId.aboutCardExpandedActiveCls.substring(1));

		const transitionEndCallback = (e: TransitionEvent) => {
			if(e.propertyName !== 'height') {
				return;
			}

			contentHtml.style.cssText = 'height: auto;opacity: 1;';
			contentHtml.classList.remove(expandedTransitionCls.substring(1));

			aboutCardBtnLessHtml.style.cssText = 'opacity: 1; visibility: visible;';

			contentHtml.removeEventListener('transitionend', transitionEndCallback);
		}

		contentHtml.addEventListener('transitionend', transitionEndCallback);

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				contentHtml.classList.add(expandedTransitionCls.substring(1));
				contentHtml.style.cssText = 'height: ' + height + '; padding-top: ' + paddingTop + ' opacity: 1;';
			});
		});
	}

	hideAboutCard() {

		const expandedTransitionCls = this.publicVars.cssId.aboutCardExpandedTransitionCls;
		const expandedActiveCls = this.publicVars.cssId.aboutCardExpandedActiveCls;

		if(!this.publicVars.cssId.aboutCardExpandedId
			|| !expandedTransitionCls
			|| !expandedActiveCls
			|| !this.publicVars.cssId.moduleHomeAboutId
			|| !this.publicVars.cssId.headerCls
			|| !this.publicVars.cssId.aboutCardBtnMoreId
		) {
			this.errorMsg('missing required css classes');
			return;
		}

		const contentHtml = document.querySelector(this.publicVars.cssId.aboutCardExpandedId) as HTMLElement;
		const aboutCardBtnMoreHtml = document.querySelector(this.publicVars.cssId.aboutCardBtnMoreId) as HTMLElement;

		const height = contentHtml.offsetHeight + 'px';
		const paddingTop = window.getComputedStyle(contentHtml).paddingTop;

		contentHtml.style.cssText = `height: ${height}; padding-top: ${paddingTop}; opacity: 1;`;

		const transitionEndCallback = (e: TransitionEvent) => {
			if(e.propertyName !== 'height') {
				return;
			}

			contentHtml.style.cssText = 'height: auto;opacity: 1;';
			contentHtml.classList.remove(expandedTransitionCls.substring(1));
			contentHtml.classList.remove(expandedActiveCls.substring(1));
			aboutCardBtnMoreHtml.style.cssText = 'opacity: 1; visibility: visible;';

			contentHtml.removeEventListener('transitionend', transitionEndCallback);
		}

		contentHtml.addEventListener('transitionend', transitionEndCallback);

		const headerHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;

		this.service.jump?.jumpTo(this.publicVars.cssId.moduleHomeAboutId, {
			modifier: -headerHtml.offsetHeight,
			speed: 100
		}, () => {});

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				contentHtml.classList.add(expandedTransitionCls.substring(1));
				contentHtml.style.cssText = 'height: 0; padding-top: 0; opacity: 0;';
			});
		});
	}
}

export default About;